import { PageTypeEnum } from '@/constant';
import { dayjs, NOOP } from '@/utils';

import { FormikValues } from 'formik';
import { range } from 'ramda';

import { filterDateDefaultValue } from './filter-date';
import { filterTimeDefaultValue } from './filter-time';
import { filterInputCheckboxDefaultValue } from './input-checkbox';
import { EEditableFilterType, resolveFilterItem, TRootOptions } from './type';

export const multipleSearchTypeKeys = [
	PageTypeEnum.APPLICANT,
	PageTypeEnum.FRANCHISE,
	PageTypeEnum.RECOMMENDER,
	PageTypeEnum.LODGING,
];

export const startEndDateTimeFields = [
	'REGIST_DT',
	'UPDATE_DT',
	'START_DT',
	'END_DT',
];

export const typeFields = ['TYPE'];

export const getDefaultValue = (fI: TRootOptions['filterItem']) => {
	const filterItem = resolveFilterItem(fI);

	switch (filterItem?.type) {
		case EEditableFilterType.TEXT_INPUT:
			return filterItem?.inputProps?.defaultValue || '';

		case EEditableFilterType.DROPDOWN:
			return filterItem?.dropdownProps?.defaultValue || '';

		case EEditableFilterType.DATE_RANGE_PICKER:
			return filterItem?.dateProps?.defaultValue || filterDateDefaultValue;

		case EEditableFilterType.AUTOCOMPLETE:
			return filterItem?.autoCompleteProps?.defaultValue || '';

		case EEditableFilterType.CHECKBOX:
			return filterItem?.checkboxProps?.defaultChecked || false;

		case EEditableFilterType.CHECKBOX_GROUP:
			return filterItem?.checkboxGroupProps?.defaultValue || [];

		case EEditableFilterType.INPUT_TARGET:
			return {
				type: EEditableFilterType.INPUT_TARGET,
				searchType: filterItem?.dropdownProps?.defaultValue || '',
				searchValue: '',
			};

		case EEditableFilterType.INPUT_CHECKBOX:
			return (
				filterItem?.inputCheckboxProps?.defaultValue ||
				filterInputCheckboxDefaultValue
			);

		case EEditableFilterType.TIME_PICKER:
			return filterItem?.timeProps?.defaultValue || filterTimeDefaultValue;

		default:
			return '';
	}
};

export const initialValues = (data: TRootOptions[]) => {
	return data.reduce((acc, item) => {
		const filterItem = item?.filterItem;

		let value = getDefaultValue(filterItem);

		acc[item.value] = value;
		return acc;
	}, {} as FormikValues);
};

export const DEFAULT_YEARS = (() => {
	const currentYear = dayjs().year();
	let start = currentYear - 5;
	let end = currentYear + 2;
	const _years = range(start, end).reverse();

	return _years.map((year: number) => ({
		label: String(year),
		value: String(year),
	}));
})();

export const TriggerClearSearchButton = {
	click: NOOP,
};
